<template>
    <b-row class="reports-toolbar">
        <b-col md="6" lg="2" class="mb-3 mb-md-3 mb-lg-0">
            <div class="filter-wrapper">
                <b-form-select
                    v-model="statusFilter"
                    :options="statusFilters"/>
            </div>
        </b-col>
        <b-col md="6" lg="3" class="mb-3 mb-md-3 mb-lg-0">
            <div class="filter-wrapper">
                <b-input-group prepend=" ">
                    <b-form-input placeholder="Search"
                        @keydown.enter.native="search()"
                        v-model="searchString">
                    </b-form-input>
                    <b-dropdown text="Advanced" variant="primary" slot="append">
                        <b-dropdown-item v-for="(filter, index) in advanceFilters" :value="index" @click="search(filter.value)" :key="index">
                            {{ filter.text }}
                            <i v-if="advanceFilter ==  filter.value" class="ml-1"> <img width="15" height="15" src="@/assets/images/checked-symbol.svg" alt="" class="mr-1">
                            </i>
                        </b-dropdown-item>
                    </b-dropdown>
                </b-input-group>
            </div>
        </b-col>
        <b-col lg="7" class="text-left text-lg-right">
            <b-form-file
                hidden
                accept=".tsv"
                ref="importCsv"
                v-model="file.csvfile">
            </b-form-file>
            <b-button
                variant="primary btn-table-import"
                @click="browseCSV">
                <template v-if="uploading">
                    Uploading...
                </template>
                <template v-else>
                    Upload TSV
                </template>
            </b-button>
            <b-input-group class="d-inline-flex">
                <b-button variant="export-opts ml-3 text-left" disabled>
                    Export
                </b-button>
                <template slot="append">
                    <b-dropdown>
                        <b-dropdown-item
                            @click="exportAssetMaster('excel')">
                            Excel
                        </b-dropdown-item>
                        <b-dropdown-item
                            @click="exportAssetMaster('pdf')">
                            PDF
                        </b-dropdown-item>
                    </b-dropdown>
                </template>
            </b-input-group>
        </b-col>
    </b-row>
</template>

<script>
import { mapState } from "vuex";
import notification from "../../../services/notification";

export default {
    name: "AssetMasterToolbar",
    data() {
        return {
            statusFilter: "all",
            statusFilters: [
                {
                    value: "all",
                    text: "Show All"
                }
            ],
            searchString: "",
            file: {
                csvfile: null,
                error_type:
                    "You have used an invalid file format. Please check the file format and try again. <br/> Note: Only TSV file is acceptable in the system."
            },
            advanceFilter: null,
            advanceFilters: [{ value: null, text: "All" }],
            filterLabels: []
        };
    },
    computed: {
        ...mapState("reportsAsset", [
            "loading",
            "uploading",
            "import",
            "importfile",
            "importBase",
            "param",
            "filters",
            "confirm"
        ])
    },
    created: function() {
        this.getFilters();
    },
    methods: {
        search: async function(filter) {
            if (filter !== undefined) {
                this.advanceFilter = filter;
            } else if (window.event.code === "Enter") {
                filter = this.advanceFilter;
            }
            let param = {
                keyword: this.searchString ? this.searchString : null,
                filter: this.advanceFilter
            };
            let page = this.param.page;

            await this.$store.dispatch("reportsAsset/getList", {
                param,
                page
            });
        },

        confirmUpload: function(file) {
            this.$store.commit("reportsAsset/setConfirmModal", true);
            this.$store.commit("reportsAsset/setImportAsset", file);
        },

        browseCSV: function() {
            this.$refs.importCsv.$el.children[0].click();
        },

        exportAssetMaster: async function(format) {
            switch (format) {
                case "excel":
                    await this.$store.dispatch("reportsAsset/exportXls", this.param.param);
                    break;
                case "pdf":
                    await this.$store.dispatch("reportsAsset/exportPdf",
                    this.param.param);
                    break;
            }
        },

        getFilters: async function() {
            await this.$store.dispatch("reportsAsset/getFilters")
                .then(async () => {
                    let keys = Object.keys(this.filters.filters);
                    let values = Object.values(this.filters.filters);

                    for (var i = 0; keys.length > i; i++) {
                        let transform_text = values[i].split(" ");
                        await this.transformFilterText(transform_text);
                        let filter = {
                            value: keys[i],
                            text: this.filterLabels[i]
                        };
                        this.advanceFilters.push(filter);
                    }
                });
        },

        transformFilterText: async function(text) {
            let labels = [];
            for (var i = 0; text.length > i; i++) {
                let label = text[i].charAt(0).toUpperCase() + text[i].slice(1);
                labels.push(label);
            }
            await this.filterLabels.push(labels.join(" "));
        }
    },
    watch: {
        "file.csvfile": async function(file) {
            if (file !== null) {
                if (file !== null) {
                    this.confirmUpload(file);
                }
            }
        },

        searchString: async function(keyword) {
            let param = {
                keyword: keyword ? keyword : null,
                filter: this.advanceFilter
            };
            let page = this.param.page;

            await this.$store.commit("reportsAsset/setParam", {
                param,
                page
            });

            await this.$store.dispatch("reportsAsset/getList", this.param);
        },

        import: function() {
            if (this.import) {
                let _this = this;
                this.$store.dispatch("reportsAsset/importAsset");
                this.$store.dispatch("reportsAsset/getList", _this.param);
                this.$refs.importCsv.reset();
            }
        },
        
        confirm: function(value) {
            if (value === false) {
                this.$refs.importCsv.reset();
            }
        }
    }
}
</script>
